import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import Swal from 'sweetalert2';

import { db, storage } from "../../../firebase"; // Assuming you have initialized Firebase Storage as 'storage'
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const ProjectForm = () => {
  const [formData, setFormData] = useState({
    title: "",
    image: null,
    isBlog: false,
    description: "",
    githubLink: "",
    demoLink: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    const val = type === "checkbox" ? checked : type === "file" ? files[0] : value;
    setFormData((prevData) => ({
      ...prevData,
      [name]: val
    }));
  };

  const handleFileUpload = async (file) => {
    // Create a reference to the file in Firebase Storage
    const storageRef = ref(storage, file.name);
  
    try {
      // Upload file to Firebase Storage
      const snapshot = await uploadBytes(storageRef, file);
  
      // Get download URL for the file
      const downloadURL = await getDownloadURL(snapshot.ref);
  
      return downloadURL;
    } catch (error) {
      console.error('Error uploading file: ', error);
      throw error; // Re-throw the error to handle it in the calling function
    }
  };

  const [cities, setCities] = useState([]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const querySnapshot = await getDocs(collection(db, 'ProjectData'));
  //       querySnapshot.forEach((doc) => {
          
  //         console.log(doc.data().title);
  //       });
  //       setCities(citiesData);
  //     } catch (error) {
  //       console.error('Error fetching cities:', error);
  //     }
  //   };

  //   fetchData();
  // }, []); 
  const checkTitleExists = async (title1) => {
    try {
      const querySnapshot = await getDocs(
        query(collection(db, 'ProjectData'), where('title', '==', title1))
      );
      return !querySnapshot.empty; // Return true if any documents match the query
    } catch (error) {
      console.error('Error checking title existence: ', error);
      
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const titleExists = await checkTitleExists(formData.title);
    if (titleExists) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Name already taken'
      });
      return;
    }
  
    // Regex patterns
    const githubLinkPattern = /^https?:\/\/(?:www\.)?github\.com\/\w+(?:\/[-\w]+)*(?:\/)?$/;
    const demoLinkPattern = /^https?:\/\/(?:www\.)?[-\w@:%.~\/?&=]+$/;
  
    // Validation messages
    const validationMessages = {
      githubLink: 'Please enter a valid GitHub link.',
      demoLink: 'Please enter a valid demo link.',
      title: 'Title must be at least 5 words.',
      description: 'Description must be at least 5 words.'
    };
  
    // Validate GitHub link
    if (!githubLinkPattern.test(formData.githubLink)) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: validationMessages.githubLink
      });
      return;
    }
  
    // Validate demo link
    if (!demoLinkPattern.test(formData.demoLink)) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: validationMessages.demoLink
      });
      return;
    }
  
    // Validate title (at least 5 words)
    if (formData.title.split(/\s+/).length < 2) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: validationMessages.title
      });
      return;
    }
  
    // Validate description (at least 5 words)
    if (formData.description.split(/\s+/).length < 5) {
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: validationMessages.description
      });
      return;
    }
  
    try {
      // If all validations pass, proceed with adding the document to Firestore
      // If there's an image, upload it first and get the download URL
      let imageUrl = null;
      if (formData.image) {
        imageUrl = await handleFileUpload(formData.image);
      }
  
      // Add document to Firestore
      const docRef = await addDoc(collection(db, "ProjectData"), {
        title: formData.title,
        image: imageUrl,
        isBlog: formData.isBlog,
        description: formData.description,
        githubLink: formData.githubLink,
        demoLink: formData.demoLink
      });
  
      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Congratulations!',
        text: 'You have added the project.'
      });
  
      // Clear form after successful submission
      setFormData({
        title: "",
        image: null,
        isBlog: false,
        description: "",
        githubLink: "",
        demoLink: ""
      });
    } catch (error) {
      console.error('Error adding document: ', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to add the project. Please try again.'
      });
    }
  };
  
  return (
    <div style={{ width: '100%',display:'flex',justifyContent:'center' }}>
    <Form style={{ width: '90%'}} onSubmit={handleSubmit}>
    <h1>
    ADD Project Form
    </h1>
      <Row>
        <Col sm={6}>
          <Form.Group controlId="formTitle">
            <Form.Label>Project Title</Form.Label>
            <Form.Control
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter project title"
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="formImage">
            <Form.Label>Project Image</Form.Label>
            <Form.Control
              type="file" // Changed to file type for upload
              name="image"
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <Form.Group controlId="formIsBlog">
            <Form.Label>Is Blog Post?</Form.Label>
            <Form.Select
              name="isBlog"
              value={formData.isBlog.toString()} // Convert boolean to string
              onChange={handleChange}
            >
              <option value="true">True</option>
              <option value="false">False</option>
            </Form.Select>
          </Form.Group>
        </Col>

        <Col sm={6}>
          <Form.Group controlId="formDescription">
            <Form.Label>Project Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter project description"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <Form.Group controlId="formGithubLink">
            <Form.Label>Github Link</Form.Label>
            <Form.Control
              type="text"
              name="githubLink"
              value={formData.githubLink}
              onChange={handleChange}
              placeholder="Enter Github link"
            />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group controlId="formDemoLink">
            <Form.Label>Demo Link</Form.Label>
            <Form.Control
              type="text"
              name="demoLink"
              value={formData.demoLink}
              onChange={handleChange}
              placeholder="Enter demo link"
            />
          </Form.Group>
        </Col>
      </Row>

      <Button style={{marginTop:'40px'}} variant="primary" type="submit">
        Add Project
      </Button>
    </Form>
    </div>
  );
};

export default ProjectForm;
